import React from 'react';
import styles from './Breadcrumb.module.scss';
import caretRightIcon from 'assets/images/caret-right-icon.svg';
import PropTypes from 'prop-types';
import { ROUTE_LIST } from 'constants/components';
import { useLocation } from 'react-router-dom';

const Breadcrumb = ({ navigateHistory, navigateTo }) => {
    const { pathname } = useLocation();

    if (!pathname || pathname === '/') {
        return null;
    }

    if (navigateHistory.length === 0 && pathname !== '/') {
        return (
            <div className={styles.wrapper}>
                <div
                    className={`${styles.path} ${styles.current}`}
                    onClick={() => navigateTo(pathname, '/')}
                >
                    Home
                </div>
                <div className={styles.icon}>
                    <img src={caretRightIcon} alt="" />
                </div>
                <div className={`${styles.path} ${styles.current}`}>
                    {ROUTE_LIST.find((s) => s.path === pathname).name}
                </div>
            </div>
        );
    }

    return (
        <div className={styles.wrapper}>
            {navigateHistory.map((history, index) => {
                return (
                    <React.Fragment key={index}>
                        <div
                            className={`${styles.path} ${styles.current}`}
                            onClick={() => navigateTo(pathname, history)}
                        >
                            {ROUTE_LIST.find((s) => s.path === history).name}
                        </div>
                        <div className={styles.icon}>
                            <img src={caretRightIcon} alt="" />
                        </div>
                    </React.Fragment>
                );
            })}
            <div className={`${styles.path} ${styles.current}`}>
                {ROUTE_LIST.find((s) => s.path === pathname).name}
            </div>
        </div>
    );
};

Breadcrumb.propTypes = {
    navigateHistory: PropTypes.array,
    navigateTo: PropTypes.func
};
export default Breadcrumb;
